import * as React from 'react';

import { connect } from 'react-redux';
import AppState from '@webapp/store/state';

import styled from 'styled-components';

import NavbarItemAvatarCtrl from '../navbar-items/navbar-item-avatar';

interface NavbarActionsOnlyNameCtrlProps {
  className?: string;
  isMobile: boolean;
}

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
});

export const NavbarActionsOnlyNameCtrl: React.FC<
  NavbarActionsOnlyNameCtrlProps
> = (props) => {
  return !props.isMobile ? (
    <div className={props.className}>
      <NavbarItemAvatarCtrl className="navbar-artist" noHover noIcons />
    </div>
  ) : null;
};

export default connect(mapStateToProps)(styled(NavbarActionsOnlyNameCtrl)`
  width: 100%;
`);
